import AuditField from "./AuditField";

export default function BlocIdentite({ data }) {
  const isMorale = data.type === "Personne Morale";

  return (
    <section className="space-y-6 bg-surface p-6 rounded-xl shadow">
      <h2 className="text-xl font-bold text-primary">
        {isMorale ? "Identité de la Société" : "Identité du Foyer"}
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {isMorale ? (
          <>
            <AuditField label="Dénomination" value={data.denomination || data.nom} />
            <AuditField label="Statut juridique" value={data.statutJuridique} />
            <AuditField label="SIRET" value={data.siret} />
            <AuditField label="Secteur d'activité" value={data.secteurActivite} />
            <AuditField label="Date de création" value={data.dateCreation?.slice(0, 10)} />
            <AuditField label="Capital social (€)" value={data.capitalSocial?.toLocaleString()} />
            <AuditField label="Adresse" value={data.adresse} />
            <AuditField label="Code postal" value={data.codePostal} />
            <AuditField label="Ville" value={data.ville} />
            <AuditField label="Pays" value={data.pays} />
            <AuditField label="Email" value={data.email} />
            <AuditField label="Téléphone" value={data.telephone} />
            <AuditField label="Site web" value={data.siteWeb} />
          </>
        ) : (
          <>
            <AuditField label="Nom du Foyer" value={data.nomFamille || data.nom} />
            <AuditField label="Email (Référence)" value={data.email || data.reference} />
            <AuditField label="Situation matrimoniale" value={data.situationMatrimoniale} />
            <AuditField label="Régime matrimonial" value={data.regimeMatrimonial} />
            <AuditField label="Date de mariage" value={data.dateMariage?.slice(0, 10)} />
            <AuditField label="Pays de Résidence Fiscale" value={data.paysResidence} />
            <AuditField label="Famille recomposée" value={data.familleRecomposee ? "Oui" : "Non"} />
            <AuditField label="Commentaire interne" value={data.commentaire} />
          </>
        )}
      </div>
    </section>
  );
}
